import PropTypes from 'prop-types';
import { memo } from 'react';

import Button from 'shopper/components/Button';
import Icon from 'shopper/components/Icon';
import Tooltip from 'shopper/components/Tooltip';

import placeholder from 'lib/placeholder';

const DislikeButton = ({ isDisliked, onClick }) => (
  <Tooltip.Root>
    <Tooltip.Trigger>
      <Button
        className="[&>span]:text-neutral-low-300 [&>svg]:text-neutral-low-300"
        icon={
          isDisliked ? <Icon name="dislike-filled" /> : <Icon name="dislike" />
        }
        size="size4"
        type={isDisliked ? 'disliked' : 'dislike'}
        onClick={onClick}
      />
    </Tooltip.Trigger>
    <Tooltip.Box className="w-max">
      {isDisliked ? placeholder('tips.disliked') : placeholder('tips.dislike')}
    </Tooltip.Box>
  </Tooltip.Root>
);

DislikeButton.propTypes = {
  isDisliked: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default memo(DislikeButton);
